import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import authGuard from './authGuard';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/customers',
    name: 'Customers',
    component: () => import(/* webpackChunkName: "customers" */ '../views/Customers.vue'),
    beforeEnter: authGuard,
  },
  {
    path: '/customers/new',
    name: 'NewCustomer',
    component: () => import(/* webpackChunkName: "newcustomer" */ '../views/CustomersNew.vue'),
    beforeEnter: authGuard,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
